import { NamedRef, RfidTagListItem } from '@/models';

const DASH = '-';

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return DASH;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return DASH;
  return date.toLocaleString();
}

export interface AssignedToDisplay {
  name: string;
  email: string;
}

export function formatAssignedTo(item: RfidTagListItem): AssignedToDisplay {
  if (!item.user) return { name: DASH, email: '' };
  const fullName = `${item.user.firstName ?? ''} ${item.user.lastName ?? ''}`.trim();
  const email = item.user.email ?? '';
  const name = fullName || email || DASH;
  return { name, email };
}

export function joinNamedRefs(items: NamedRef[] | undefined | null): string {
  if (!items || items.length === 0) return DASH;
  return items.map((i) => i.name).join(', ');
}
